import { useState } from 'react';
import { Navigation } from 'lucide-react';

import { IconButtonTemplate } from '../../buttons/IconButtonTemplate';
import {
  Popover,
  PopoverContent,
  PopoverTrigger,
} from '../../shadcn/popover';

const isIOS = () =>
  /iPad|iPhone|iPod/.test(navigator.userAgent) ||
  (navigator.platform === 'MacIntel' && navigator.maxTouchPoints > 1);

const isAndroid = () => /Android/i.test(navigator.userAgent);

const getMapApps = (latitude, longitude, label) => {
  const coords = `${latitude},${longitude}`;

  if (isIOS()) {
    const apple = new URLSearchParams({ ll: coords, q: label || coords });
    const google = new URLSearchParams({ q: coords, center: coords, zoom: '17' });
    return [
      { title: 'Apple Maps', url: `maps://?${apple}` },
      { title: 'Google Maps', url: `comgooglemaps://?${google}` },
    ];
  }

  if (isAndroid()) {
    const google = new URLSearchParams({ q: coords });
    return [
      {
        title: 'Google Maps',
        url: `intent://maps.google.com/maps?${google}#Intent;scheme=https;package=com.google.android.apps.maps;end`,
      },
    ];
  }

  return [];
};

export const OpenInMapsButton = ({ latitude, longitude, label = '' }) => {
  const [isOpen, setIsOpen] = useState(false);

  if (latitude == null || longitude == null) return null;

  const apps = getMapApps(latitude, longitude, label);
  if (!apps.length) return null;

  const openApp = url => {
    setIsOpen(false);
    window.location.href = url;
  };

  if (apps.length === 1) {
    return (
      <IconButtonTemplate
        icon={Navigation}
        size={14}
        isSmall={true}
        isRounded={true}
        handleClick={() => openApp(apps[0].url)}
      />
    );
  }

  return (
    <Popover open={isOpen} onOpenChange={setIsOpen}>
      <PopoverTrigger asChild>
        <span className="inline-flex">
          <IconButtonTemplate
            icon={Navigation}
            size={14}
            isSmall={true}
            isRounded={true}
          />
        </span>
      </PopoverTrigger>
      <PopoverContent className="flex flex-col w-auto p-1" align="end">
        {apps.map(app => (
          <button
            key={app.title}
            type="button"
            className="px-3 py-2 text-sm text-left text-blackColor rounded hover:bg-gray-100"
            onClick={() => openApp(app.url)}
          >
            {app.title}
          </button>
        ))}
      </PopoverContent>
    </Popover>
  );
};
